import { AfterViewInit, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CardHolder, CardModel, IPlatformToolCard, MagicLinkModel } from '@shared/models/platform-tool-models';
import { IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { FlexSheetService } from '@features/spreadsheet/services/flex-sheet.service';
import { PlatformQueryResponse } from '@shared/models/platform-query/platform-query';
import { PlatformCommand } from '@shared/commands/command-base';
import { take } from 'rxjs/operators';
import { CommandService } from '@core/services/command.service';
import { DialogService } from '@shared/services/dialog-service';
import { ExcelHelper } from '@features/spreadsheet/helpers/excel-helper';
import { SnackBarService } from '@core/services/snack-bar.service';
import { DialogModel } from "@shared/models/dialog.model";
import { Api } from '@shared/constants/common-field.constants';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import { TableType } from "@features/spreadsheet/constants/table-type.model";
import tableConfigJson from "./table-configuration.json";
import {simplifySelection} from '@codemirror/commands';

@Component({
  standalone: false,
  selector: 'app-excel-table-input-card',
  templateUrl: './excel-table-input-card.component.html',
  styleUrls: ['./excel-table-input-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExcelTableInputCardComponent implements OnInit, AfterViewInit, IPlatformToolCard {

  @Input() magicLinkModel: MagicLinkModel;
  @Input() handler: IPlatformToolHandler;
  @Input() invalidateSubject: InvalidateSubject;
  @Input() cardHolder: CardHolder;
  @Input() card: CardModel;
  @Input() queryResponse: PlatformQueryResponse;
  isFetched = false;
  isTrialBalance = false;
  isTransaction = false;
  isMatrix = false;
  tableType: string;
  invalid = true;
  transposeTableType: string;
  tableConfigInfo: any;
  isAutoDetectVisible: boolean;

  excelTableInput: any = {
    questionnaireName: '',
    tableType: '',
    headerRow: '',
    startColumn: '',
    endColumn: '',
    startDataRow: '',
    endDataRow: '',
    modelRow: '',
    isModelRowSupported: false,
    isDefaultModelRowLocked: false,
    isTransposedTable: false,
    headerColumn: '',
    startRow: '',
    endRow: '',
    dataStartColumn: '',
    dataModelColumn: '',
    trialBalanceInputs: {
      entityCodeRow: '',
      entityCodeColumn: '',
      entityNameRow: '',
      entityNameColumn: '',
      accountCodeColumn: '',
      accountNameColumn: '',
      currencyRow: '',
      currencyColumn: '',
      amountColumn: '',
      accountCodeRow: '',
      accountNameRow: '',
      amountRow: ''
    },
    transactionInputs: {
      payorEntityCodeRow: '',
      payorEntityCodeColumn: '',
      payorEntityNameColumn: '',
      payorEntityTypeColumn: '',
      eliminationColumn: '',
      paymentAfterElimColumn: '',
      payeeEntityCodeRow: '',
      payeeEntityCodeColumn: '',
      payeeEntityNameRow: '',
      payeeEntityTypeRow: '',
      countryRow: '',
      startDataRow: '',
      dataStartColumn: ''
    }
  };
  public tableConfigJson: any;

  constructor(public flexSheetService: FlexSheetService,
    private commandService: CommandService,
    private dialogService: DialogService,
    private snackBarService: SnackBarService,
    private fuseSplashScreenService: FuseSplashScreenService) { }

  ngAfterViewInit(): void {
    this.excelTableInput.questionnaireName = this.queryResponse.fieldValues['QuestionnaireName'];
    setTimeout(() => {
      this.excelTableInput.questionnaireName = this.queryResponse.fieldValues['QuestionnaireName'] ? this.queryResponse.fieldValues['QuestionnaireName'] : this.flexSheetService.getCurrentWorkBook().name + '-' + (this.flexSheetService.getCurrentWorkSheet() ? this.flexSheetService.getCurrentWorkSheet().name : '');

    }, 3000);

    this.excelTableInput.tableType = this.queryResponse.fieldValues['TableType'] ? this.queryResponse.fieldValues['TableType'] : '';
    this.excelTableInput.headerRow = this.queryResponse.fieldValues['HeaderRow'] ? this.queryResponse.fieldValues['HeaderRow'] : '';
    this.excelTableInput.startColumn = this.queryResponse.fieldValues['StartColumn'] ? this.queryResponse.fieldValues['StartColumn'] : '';
    this.excelTableInput.endColumn = this.queryResponse.fieldValues['EndColumn'] ? this.queryResponse.fieldValues['EndColumn'] : '';
    this.excelTableInput.startDataRow = this.queryResponse.fieldValues['StartDataRow'] ? this.queryResponse.fieldValues['StartDataRow'] : '';
    this.excelTableInput.endDataRow = this.queryResponse.fieldValues['EndDataRow'] ? this.queryResponse.fieldValues['EndDataRow'] : '';
    this.excelTableInput.modelRow = (this.queryResponse.fieldValues['ModelRow'] && this.queryResponse.fieldValues['ModelRow'] != -1) ? this.queryResponse.fieldValues['ModelRow'] : '';
    this.excelTableInput.isDefaultModelRowLocked = this.queryResponse.fieldValues['IsDefaultModelRowLocked'] === true ? true : false;
    this.excelTableInput.isTransposedTable = this.queryResponse.fieldValues['IsTransposedTable'] === true ? true : false;
    this.excelTableInput.isModelRowSupported = this.queryResponse.fieldValues['IsModelRowSupported'] ? this.queryResponse.fieldValues['IsModelRowSupported'] : '';
  }


  ngOnInit(): void {
    this.tableType = this.queryResponse.fieldValues['TableType'] ? this.queryResponse.fieldValues['TableType'] : '';
    this.isTrialBalance = this.tableType.startsWith('TrialBalance');
    this.isTransaction = this.tableType === TableType.Transaction;
    this.isMatrix = this.tableType === TableType.Matrix;
    this.invalid = this.isTrialBalance || this.isTransaction || this.isMatrix;

    this.tableConfigJson = tableConfigJson;
    if(this.tableConfigJson && this.tableType) {
      this.transposeTableType = "Standard";
      this.tableConfigInfo = tableConfigJson[this.tableType]?.[this.transposeTableType] || {};
    }

    this.isAutoDetectVisible = [
      TableType.StandardTable,
      TableType.TrialBalanceMultipleEntities,
      TableType.TrialBalanceSingleEntity,
      TableType.Transaction,
      TableType.Matrix
    ].includes(this.tableType);

  }
  onLoad() {

  }

  toggleTable() {

    if (this.transposeTableType) {
      this.transposeTableType = this.transposeTableType === "Standard" ? "Transposed" : "Standard";
    }

    // if (this.transposeTableType === "Transposed") {
    //   this.excelTableInput.isTransposedTable = true;
    // } else {
    //   this.excelTableInput.isTransposedTable = false;
    // }

    this.tableConfigInfo = tableConfigJson[this.tableType][this.transposeTableType];
  }

  showTextEditor(title: string, value: any, callback?, isOptional = false) {
    this.dialogService.showOkCancelDialog(
      DialogModel.create(title, 'TextInputDialogViewComponent', {
        text: value,
        extension: null,
        checkRegex: null,
        placeHolder: title,
        isOptional: (isOptional || (title === "Model Row" || title === "Model Column" || title === "")) ? true : false
      }, '400px', '530px', false, 40)
    ).pipe(take(1)).subscribe(res => {
      if (res.action === 'OK') {
        if ((res.data.input && res.data.input.text && res.data.input.text.toString().length > 0) || (res.data.input.isOptional && res.data.input.text === '')) {
          callback(res.data.input.text);
        }
      }
    });
  }
  setData(title: string, key: string, type: string, source: string = '', isOptional = false) {
    if (type === 'qnrTitle') {
      this.showTextEditor(title, this.excelTableInput.questionnaireName, (val: any) => {
        this.excelTableInput[key] = val;
      }, isOptional);
    } else {
      const selectedCell = this.flexSheetService.selection.cellModel;
      const row = selectedCell ? selectedCell.er + 1 : 0;
      const col = ExcelHelper.getColumnName(selectedCell ? selectedCell.ec : 0);
      const cellValue = type === 'Row' ? row : col;

      this.showTextEditor(title, cellValue, (val: any) => {
        if (this.excelTableInput.isTransposedTable === true) {
          this.validateAndSaveForTranspose(key, val);
        } else {
          this.validateAndSave(key, val);
        }
        if (source === 'Transaction') {
          this.validateAndSaveForTransaction(title, key, type, val, selectedCell, isOptional);
          this.invalid = this.isInvalidTransactionInput();
        }
        if (source === 'Matrix') {
          this.invalid = this.isInvalidMatrixInput();
        }
        if (source === 'TrialBalance') {
          this.validateAndSaveForTrialBalance(title, key, type, val, selectedCell, isOptional);
          this.invalid = this.isInvalidInput();
        }
      }, isOptional);
    }
  }
  validateAndSave(key: string, val: any) {
    let isValidate = false;
    let validationMessage = '';
    switch (key) {
      case 'headerRow':
        const headerRow = +val;
        if (headerRow) {
          isValidate = true;
        } else {
          validationMessage = 'Header row should be in right format.';
        }
        break;
      case 'startColumn':
        const startColumn = val as string;
        if (/^[A-Z]+$/.test(startColumn)) {
          isValidate = true;
        } else {
          validationMessage = 'Start column should be in right format.';
        }
        break;
      case 'endColumn':
        const endColumn = val as string;
        if (/^[A-Z]+$/.test(endColumn)) {
          isValidate = true;
        } else {
          validationMessage = 'End column should be in right format.';
        }
        break;
      case 'startDataRow':
        var startRow = +val;
        if (startRow) {
          isValidate = true;
        } else {
          validationMessage = 'Start row should be in right format.';
        }
        break;
      case 'endDataRow':
        var endRow = +val;
        var startRow = +this.excelTableInput['startDataRow'];
        if (endRow && (!startRow || endRow >= startRow)) {
          isValidate = true;
        } else {
          validationMessage = endRow ? 'End row should be greater that Start row.' : 'End row should be in right format.';
        }
        break;
      case 'modelRow':
        this.excelTableInput.isModelRowSupported = true;
        let modelRow = val;
        if (val == '') modelRow = -1;
        if (modelRow) { isValidate = true; } else {

        }
        break;
      default:
        isValidate = true;
        break;
    }
    if (isValidate) {
      this.excelTableInput[key] = val;
    } else {
      this.snackBarService.showError(validationMessage);
    }
  }
  validateAndSaveForTranspose(key: string, val: any) {
    let isValidate = false;
    let validationMessage = '';
    switch (key) {
      case 'headerColumn':
        const headerRow = val as string;
        if (/^[A-Z]+$/.test(headerRow)) {
          isValidate = true;
        } else {
          validationMessage = 'Header column should be in right format.';
        }
        break;

      case 'startRow':
        const startColumn = val as string;
        if (startColumn) {
          isValidate = true;
        } else {
          validationMessage = 'Start row should be in right format.';
        }
        break;
      case 'endRow':
        const endColumn = val as string;
        if (endColumn) {
          isValidate = true;
        } else {
          validationMessage = 'End row should be in right format.';
        }
        break;
      case 'dataStartColumn':
        var dataStartColumn = val as string;
        if (/^[A-Z]+$/.test(dataStartColumn)) {
          isValidate = true;
        } else {
          validationMessage = 'Start data column should be in right format.';
        }
        break;
      case 'endDataRow':
        var endRow = +val;
        var startRow = +this.excelTableInput['startDataRow'];
        if (endRow && (!startRow || endRow >= startRow)) {
          isValidate = true;
        } else {
          validationMessage = endRow ? 'End row should be greater that Start row.' : 'End row should be in right format.';
        }
        break;
      case 'dataModelColumn':
        this.excelTableInput.isModelRowSupported = true;
        const dataModelColumn = val;
        if (/^[A-Z]+$/.test(dataModelColumn)) { isValidate = true; } else {
          validationMessage = 'Data model column should be in right format.';
        }
        break;
      default:
        isValidate = true;
        break;
    }
    if (isValidate) {
      this.excelTableInput[key] = val;
    } else {
      this.snackBarService.showError(validationMessage);
    }
  }

  isValidInputByType(type: string, val: any, isOptional: boolean = false) {
    let isValidate = false;
    switch (type) {
      case 'Col':
        const column = val as string;
        if (/^[A-Z]+$/.test(column)) {
          isValidate = true;
        }
        break;
      case 'Row':
        const startRow = +val;
        if (startRow) {
          isValidate = true;
        }
        break;
      default:
        isValidate = true;
        break;
    }
    if (val === '' && isOptional) {
      isValidate = true;
    }
    return isValidate;
  }
  validateAndSaveForTransaction(title: string, key: string, type: string, val: any, selectedCell: any, isOptional: boolean = false) {
    const isValidate = this.isValidInputByType(type, val, isOptional);
    if (isValidate) {
      this.excelTableInput.transactionInputs[key] = val;
      this.autoUpdateTransactionRelativeField(key, selectedCell);
    } else {
      this.snackBarService.showError(`${title} should be in right format.`);
    }
  }
  validateAndSaveForTrialBalance(title: string, key: string, type: string, val: any, selectedCell: any, isOptional: boolean = false) {
    const isValidate = this.isValidInputByType(type, val, isOptional);
    if (isValidate) {
      this.excelTableInput.trialBalanceInputs[key] = val;
      this.autoUpdateRelativeRowColumn(key, type, selectedCell);
      switch (this.tableType) {
        case TableType.TrialBalanceSingleEntity:
          this.autoUpdateSingleEntityRelativeField(key, type, val, selectedCell);
          break;
        case TableType.TrialBalanceMultipleEntities:
          this.autoUpdateMultipleEntitiesRelativeField(key, type, val, selectedCell);
          break;
        default:
          break;
      }
    } else {
      this.snackBarService.showError(`${title} should be in right format.`);
    }
  }
  getAntiKeyValue(type: string, key: string, selectedCell: any): any {
    if (key === 'accountCodeColumn') {
      return { key: 'accountNameColumn', value: ExcelHelper.getColumnName(selectedCell ? selectedCell.ec + 1 : 0) };
    }
    if (key === 'accountNameColumn') {
      return { key: 'accountCodeColumn', value: ExcelHelper.getColumnName(selectedCell ? selectedCell.ec - 1 : 0) };
    }

    if (key === 'startDataRow') {
      return { key: 'dataStartColumn', value: ExcelHelper.getColumnName(selectedCell ? selectedCell.ec : 0) };
    }
    if (key === 'dataStartColumn') {
      return { key: 'startDataRow', value: selectedCell ? selectedCell.er + 1 : 0 };
    }

    if (type === 'Row') {
      return { key: key.replace('Row', 'Column'), value: ExcelHelper.getColumnName(selectedCell ? selectedCell.ec : 0) };
    } else {
      return { key: key.replace('Column', 'Row'), value: selectedCell ? selectedCell.er + 1 : 0 };
    }
  }

  autoUpdateRelativeRowColumn(key: string, type: string, selectedCell: any): void {
    const antiKeyValue = this.getAntiKeyValue(type, key, selectedCell);
    const antiKey = antiKeyValue.key;
    const value = antiKeyValue.value;
    if (this.excelTableInput.trialBalanceInputs.hasOwnProperty(antiKey) && this.excelTableInput.trialBalanceInputs[antiKey] === '') {
      this.excelTableInput.trialBalanceInputs[antiKey] = value;
    }
    if (this.excelTableInput.hasOwnProperty(antiKey) && this.excelTableInput[antiKey] === '') {
      this.excelTableInput[antiKey] = value;
    }
  }
  autoUpdateSingleEntityRelativeField(key: string, type: string, val: any, selectedCell: any) {
    if (key === 'entityCodeColumn' || key === 'entityNameColumn' || key === 'accountNameColumn') {
      this.excelTableInput.trialBalanceInputs.entityCodeColumn = this.getActualValue(this.excelTableInput.trialBalanceInputs.entityCodeColumn, val);
      this.excelTableInput.trialBalanceInputs.entityNameColumn = this.getActualValue(this.excelTableInput.trialBalanceInputs.entityNameColumn, val);
      this.excelTableInput.trialBalanceInputs.accountNameColumn = this.getActualValue(this.excelTableInput.trialBalanceInputs.accountNameColumn, val);
    }
    const selectedRow = selectedCell ? selectedCell.er + 1 : 1;
    if (key === 'entityCodeColumn') {
      this.excelTableInput.trialBalanceInputs.entityNameRow = this.getActualValue(this.excelTableInput.trialBalanceInputs.entityNameRow, selectedRow + 1);
    }
    if (key === 'entityNameColumn') {
      this.excelTableInput.trialBalanceInputs.entityCodeRow = this.getActualValue(this.excelTableInput.trialBalanceInputs.entityCodeRow, selectedRow - 1);
    }
  }
  autoUpdateMultipleEntitiesRelativeField(key: string, type: string, val: any, selectedCell: any) {
    if (key === 'entityCodeRow') {
      this.excelTableInput.trialBalanceInputs.entityNameRow = this.getActualValue(this.excelTableInput.trialBalanceInputs.entityNameRow, +val + 1);
      this.excelTableInput.trialBalanceInputs.entityNameColumn = this.getActualValue(this.excelTableInput.trialBalanceInputs.entityNameColumn, ExcelHelper.getColumnName(selectedCell ? selectedCell.ec : 0));
      this.excelTableInput.startDataRow = this.getActualValue(this.excelTableInput.startDataRow, +val + 2);
    }
    if (key === 'entityNameRow') {
      this.excelTableInput.trialBalanceInputs.entityCodeRow = this.getActualValue(this.excelTableInput.trialBalanceInputs.entityCodeRow, +val - 1);
      this.excelTableInput.trialBalanceInputs.entityCodeColumn = this.getActualValue(this.excelTableInput.trialBalanceInputs.entityCodeColumn, ExcelHelper.getColumnName(selectedCell ? selectedCell.ec : 0));
      this.excelTableInput.startDataRow = this.getActualValue(this.excelTableInput.startDataRow, +val + 1);
    }
    if (key === 'accountCodeColumn' || key === 'accountNameColumn') {
      this.excelTableInput.dataStartColumn = this.getActualValue(this.excelTableInput.dataStartColumn, ExcelHelper.getNextColumnName(this.excelTableInput.trialBalanceInputs.accountNameColumn));
    }
  }
  autoUpdateTransactionRelativeField(key: string, selectedCell: any) {
    const currentRow = this.getRowNumber(selectedCell);
    const currentColumn = this.getColumnNumber(selectedCell);
    if (key === 'payorEntityCodeRow') {
      this.excelTableInput.transactionInputs.payorEntityCodeColumn =
        this.getActualValue(this.excelTableInput.transactionInputs.payorEntityCodeColumn, ExcelHelper.getColumnName(currentColumn));
      this.excelTableInput.transactionInputs.payorEntityNameColumn =
        this.getActualValue(this.excelTableInput.transactionInputs.payorEntityNameColumn, ExcelHelper.getNextColumnName(this.excelTableInput.transactionInputs.payorEntityCodeColumn));
      this.excelTableInput.transactionInputs.payorEntityTypeColumn =
        this.getActualValue(this.excelTableInput.transactionInputs.payorEntityTypeColumn, ExcelHelper.getNextColumnName(this.excelTableInput.transactionInputs.payorEntityNameColumn));
    }
    if (key === 'payorEntityCodeColumn') {
      this.excelTableInput.transactionInputs.payorEntityCodeRow =
        this.getActualValue(this.excelTableInput.transactionInputs.payorEntityCodeRow, currentRow + 1);
      this.excelTableInput.transactionInputs.payorEntityNameColumn =
        this.getActualValue(this.excelTableInput.transactionInputs.payorEntityNameColumn, ExcelHelper.getNextColumnName(this.excelTableInput.transactionInputs.payorEntityCodeColumn));
      this.excelTableInput.transactionInputs.payorEntityTypeColumn =
        this.getActualValue(this.excelTableInput.transactionInputs.payorEntityTypeColumn, ExcelHelper.getNextColumnName(this.excelTableInput.transactionInputs.payorEntityNameColumn));
    }

    if (key === 'payeeEntityCodeRow') {
      this.excelTableInput.transactionInputs.payeeEntityCodeColumn =
        this.getActualValue(this.excelTableInput.transactionInputs.payeeEntityCodeColumn, ExcelHelper.getColumnName(currentColumn));
      this.excelTableInput.transactionInputs.payeeEntityNameRow =
        this.getActualValue(this.excelTableInput.transactionInputs.payeeEntityNameRow, currentRow + 2);
      this.excelTableInput.transactionInputs.payeeEntityTypeRow =
        this.getActualValue(this.excelTableInput.transactionInputs.payeeEntityTypeRow, currentRow + 3);
    }
    if (key === 'payeeEntityCodeColumn') {
      this.excelTableInput.transactionInputs.payeeEntityCodeRow =
        this.getActualValue(this.excelTableInput.transactionInputs.payeeEntityCodeRow, currentRow + 1);
      this.excelTableInput.transactionInputs.payeeEntityNameRow =
        this.getActualValue(this.excelTableInput.transactionInputs.payeeEntityNameRow, currentRow + 2);
      this.excelTableInput.transactionInputs.payeeEntityTypeRow =
        this.getActualValue(this.excelTableInput.transactionInputs.payeeEntityTypeRow, currentRow + 3);
    }
  }
  getRowNumber(selectedCell: any) {
    return selectedCell ? selectedCell.er : 0;
  }
  getColumnNumber(selectedCell: any) {
    return selectedCell ? selectedCell.ec : 0;
  }

  getActualValue(previousVal: string, currentVal: any) {
    if (previousVal !== '') {
      return previousVal;
    } else {
      return currentVal;
    }
  }
  isInvalidTransactionInput() {
    let invalid = false;
    Object.entries(this.excelTableInput.transactionInputs).forEach(([key, value]) => {
      if (key === '') {
        invalid = true;
      }
    });
    return invalid;
  }
  isInvalidMatrixInput(): boolean {
    let invalid = false;
    this.tableConfigInfo.FieldItems.forEach(item => {
      if (this.excelTableInput[item.CamelCaseKey] === '') {
        invalid = true;
      }
    });
    return invalid;
  }
  isInvalidInput(): boolean {
    let invalid = false;
    if (this.excelTableInput['startDataRow'] === '') {
      invalid = true;
    }
    if (this.tableType == TableType.TrialBalanceMultipleEntities && this.excelTableInput['dataStartColumn'] === '') {
      invalid = true;
    }
    Object.entries(this.tableConfigInfo?.FieldItems || {}).forEach(([_, field]: [string, any]) => {
      if (field.IsOptional && (this.tableType === TableType.TrialBalanceMultipleEntities || this.tableType === TableType.TrialBalanceStandard)) {
      } else if (this.excelTableInput.trialBalanceInputs[field?.CamelCaseKey] === '') {
        invalid = true;
      }
    });
    return invalid;
  }

  setPlatformCommandValue(platformCommand: any): any {
    platformCommand.fieldValues['WorksheetId'] = this.flexSheetService.getCurrentWorkSheet().id;
    platformCommand.fieldValues['WorkbookId'] = this.flexSheetService.getCurrentWorkBook().id;
    platformCommand.fieldValues['WorkbookSetId'] = this.flexSheetService.getCurrentWorkBookSetId();
    platformCommand.fieldValues['IsModelRowSupported'] = this.excelTableInput.isModelRowSupported;
    platformCommand.fieldValues['QuestionnaireName'] = this.excelTableInput.questionnaireName;
    platformCommand.fieldValues['IsTransposedTable'] = this.excelTableInput.isTransposedTable;
    platformCommand.fieldValues['TableType'] = this.excelTableInput.tableType;


    // transpose
    if (this.excelTableInput.isTransposedTable) {
      platformCommand.fieldValues['HeaderColumn'] = this.excelTableInput.headerColumn;
      platformCommand.fieldValues['StartRow'] = this.excelTableInput.startRow;
      platformCommand.fieldValues['EndRow'] = this.excelTableInput.endRow;
      platformCommand.fieldValues['DataStartColumn'] = this.excelTableInput.dataStartColumn;
      platformCommand.fieldValues['DataModelColumn'] = this.excelTableInput.dataModelColumn;
    } else {
      platformCommand.fieldValues['HeaderRow'] = this.excelTableInput.headerRow;
      platformCommand.fieldValues['StartColumn'] = this.excelTableInput.startColumn;
      platformCommand.fieldValues['EndColumn'] = this.excelTableInput.endColumn;
      platformCommand.fieldValues['StartDataRow'] = this.excelTableInput.startDataRow;
      platformCommand.fieldValues['EndDataRow'] = this.excelTableInput.endDataRow === '' ? -1 : this.excelTableInput.endDataRow;
      platformCommand.fieldValues['ModelRow'] = this.excelTableInput.modelRow === '' ? -1 : this.excelTableInput.modelRow;
    }

    // todo: enter trial balance informations
    platformCommand.fieldValues['EntityCodeRow'] = this.excelTableInput.trialBalanceInputs.entityCodeRow?.toString();
    platformCommand.fieldValues['EntityCodeColumn'] = this.excelTableInput.trialBalanceInputs.entityCodeColumn;
    platformCommand.fieldValues['EntityNameRow'] = this.excelTableInput.trialBalanceInputs.entityNameRow?.toString();
    platformCommand.fieldValues['EntityNameColumn'] = this.excelTableInput.trialBalanceInputs.entityNameColumn;
    platformCommand.fieldValues['AccountCodeRow'] = this.excelTableInput.trialBalanceInputs.accountCodeRow;
    platformCommand.fieldValues['AccountCodeColumn'] = this.excelTableInput.trialBalanceInputs.accountCodeColumn;
    platformCommand.fieldValues['AccountNameRow'] = this.excelTableInput.trialBalanceInputs.accountNameRow;
    platformCommand.fieldValues['AccountNameColumn'] = this.excelTableInput.trialBalanceInputs.accountNameColumn;
    platformCommand.fieldValues['AmountRow'] = this.excelTableInput.trialBalanceInputs.amountRow;
    platformCommand.fieldValues['AmountColumn'] = this.excelTableInput.trialBalanceInputs.amountColumn;
    platformCommand.fieldValues['DataStartColumn'] = this.excelTableInput.dataStartColumn;
    platformCommand.fieldValues['StartDataRow'] = this.excelTableInput.startDataRow;
    platformCommand.fieldValues['CurrencyRow'] = this.excelTableInput.currencyRow?.toString();
    platformCommand.fieldValues['CurrencyColumn'] = this.excelTableInput.currencyColumn?.toString();
    platformCommand.fieldValues['CurrencyColumn'] = this.excelTableInput.currencyColumn?.toString();
    if (this.tableConfigInfo?.TableStructureType) {
      platformCommand.fieldValues['TableStructureType'] = this.tableConfigInfo?.TableStructureType;
      platformCommand.fieldValues['TableType'] = this.tableConfigInfo?.TableStructureType;
    }
    if (this.card.fieldValues.QNRFilePath) {
      platformCommand.fieldValues['FlowchartId'] = this.card.fieldValues['FlowchartId'];
      platformCommand.fieldValues['FlowchartSectionId'] = this.card.fieldValues['FlowchartSectionId'];
      platformCommand.fieldValues['QNRFilePath'] = this.card.fieldValues['QNRFilePath'];
    }

    if (this.isTransaction) {
      Object.entries(this.excelTableInput.transactionInputs).forEach(([key, value]) => {
        platformCommand.fieldValues[this.camelToPascal(key)] = value.toString();
      });
    }
    platformCommand.fieldValues['HeaderColumn'] = this.excelTableInput.headerColumn;

    return platformCommand;
  }
  camelToPascal(str: string): string {
    return str.replace(/^[a-z]/, c => c.toUpperCase());
  }
  autoDetect() {
    let platformCommand = new PlatformCommand('AutoDetectAndFetchTableFieldsCommand', Api.Spreadsheet);
    platformCommand = this.setPlatformCommandValue(platformCommand);
    platformCommand.setValue("RelativeFolderPath", this.flexSheetService.getWorkbookSet().relativeFolderPath);
    platformCommand.setValue("FileName", this.flexSheetService.getWorkbookSet().workbookNames[0]);
    platformCommand.setValue("WorksheetName", this.flexSheetService.getCurrentWorkSheet().name);
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(response => {
      if (response && response.fieldValues) {

        if (this.excelTableInput.tableType === TableType.TrialBalanceSingleEntity) {
          this.excelTableInput.trialBalanceInputs.entityCodeRow = response.fieldValues['EntityCodeRow'] ? response.fieldValues['EntityCodeRow'] : '';
          this.excelTableInput.trialBalanceInputs.entityCodeColumn = response.fieldValues['EntityCodeColumn'] ? response.fieldValues['EntityCodeColumn'] : '';
          this.excelTableInput.trialBalanceInputs.entityNameRow = response.fieldValues['EntityNameRow'] ? response.fieldValues['EntityNameRow'] : '';
          this.excelTableInput.trialBalanceInputs.entityNameColumn = response.fieldValues['EntityNameColumn'] ? response.fieldValues['EntityNameColumn'] : '';
          this.excelTableInput.trialBalanceInputs.accountCodeColumn = response.fieldValues['AccountCodeColumn'] ? response.fieldValues['AccountCodeColumn'] : '';
          this.excelTableInput.trialBalanceInputs.accountNameColumn = response.fieldValues['AccountNameColumn'] ? response.fieldValues['AccountNameColumn'] : '';
          this.excelTableInput.trialBalanceInputs.amountColumn = response.fieldValues['AmountColumn'] ? response.fieldValues['AmountColumn'] : '';
          this.excelTableInput.dataStartColumn = response.fieldValues['DataStartColumn'] ? response.fieldValues['DataStartColumn'] : '';
          this.excelTableInput.startDataRow = response.fieldValues['StartDataRow'] ? response.fieldValues['StartDataRow'] : '';
        } else if (this.excelTableInput.tableType === TableType.TrialBalanceMultipleEntities) {
          this.excelTableInput.trialBalanceInputs.entityCodeRow = response.fieldValues['EntityCodeRow'] ? response.fieldValues['EntityCodeRow'] : '';
          this.excelTableInput.trialBalanceInputs.entityCodeColumn = response.fieldValues['EntityCodeColumn'] ? response.fieldValues['EntityCodeColumn'] : '';
          this.excelTableInput.trialBalanceInputs.entityNameRow = response.fieldValues['EntityNameRow'] ? response.fieldValues['EntityNameRow'] : '';
          this.excelTableInput.trialBalanceInputs.entityNameColumn = response.fieldValues['EntityNameColumn'] ? response.fieldValues['EntityNameColumn'] : '';
          this.excelTableInput.trialBalanceInputs.accountCodeColumn = response.fieldValues['AccountCodeColumn'] ? response.fieldValues['AccountCodeColumn'] : '';
          this.excelTableInput.trialBalanceInputs.accountCodeRow = response.fieldValues['AccountCodeRow'] ? response.fieldValues['AccountCodeRow'] : '';
          this.excelTableInput.trialBalanceInputs.accountNameColumn = response.fieldValues['AccountNameColumn'] ? response.fieldValues['AccountNameColumn'] : '';
          this.excelTableInput.trialBalanceInputs.accountNameRow = response.fieldValues['AccountNameRow'] ? response.fieldValues['AccountNameRow'] : '';
          this.excelTableInput.dataStartColumn = response.fieldValues['DataStartColumn'] ? response.fieldValues['DataStartColumn'] : '';
          this.excelTableInput.startDataRow = response.fieldValues['StartDataRow'] ? response.fieldValues['StartDataRow'] : '';
          this.invalid = this.isInvalidInput();
        } else if (this.excelTableInput.tableType === TableType.Transaction) {
          Object.entries(this.excelTableInput.transactionInputs).forEach(([key, value]) => {
            const fieldKey = this.camelToPascal(key);
            this.excelTableInput.transactionInputs[key] = response.fieldValues[fieldKey] ? response.fieldValues[fieldKey] : '';
          });
          this.invalid = this.isInvalidTransactionInput();
        } else if (this.excelTableInput.tableType === TableType.Matrix) {
          this.tableConfigInfo.FieldItems.forEach(item => {
            const fieldKey = this.camelToPascal(item.CamelCaseKey);
            this.excelTableInput[item.CamelCaseKey] = response.fieldValues[fieldKey] ? response.fieldValues[fieldKey] : '';
          });
          this.invalid = this.isInvalidMatrixInput();
        } else {
          this.excelTableInput.headerRow = response.fieldValues['HeaderRow'] ? response.fieldValues['HeaderRow'] : '';
          this.excelTableInput.startColumn = response.fieldValues['HeaderStartColumn'] ? response.fieldValues['HeaderStartColumn'] : '';
          this.excelTableInput.endColumn = response.fieldValues['HeaderEndColumn'] ? response.fieldValues['HeaderEndColumn'] : '';
          this.excelTableInput.startDataRow = response.fieldValues['DataStartRow'] ? response.fieldValues['DataStartRow'] : '';
        }
        if (response.fieldValues['RedirectCommand']) {
          const platformCommand = response.fieldValues['RedirectCommand'];
          this.fuseSplashScreenService.show();
          this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(response => {
            if (response && response.fieldValues && response.fieldValues['ExcelTableDefinitionId']) {
              this.invalidateSubject.invalidate();
              this.isFetched = true;
            }
            this.fuseSplashScreenService.hide();
          });
        }
      }
      this.fuseSplashScreenService.hide();
    });
  }

  apply() {
    let platformCommand = new PlatformCommand('ExtractExcelTableDefinitionCommand', this.flexSheetService.getApi());
    platformCommand = this.setPlatformCommandValue(platformCommand);
    const workbookSetId = this.flexSheetService.getCurrentWorkBookSetId();
    platformCommand.fieldValues['EventSourceId'] = workbookSetId;
    platformCommand.fieldValues['DestinationTransportId'] = workbookSetId;
    platformCommand.fieldValues['EventSourceApi'] = Api.Spreadsheet;
    platformCommand.fieldValues['IsEventSourceCommand'] = true;
    platformCommand.isCamelCase = true;
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(response => {
      if (response && response.fieldValues && response.fieldValues['ExcelTableDefinitionId']) {
        this.invalidateSubject.invalidate();
        this.isFetched = true;
        this.fuseSplashScreenService.hide();
      }
    }, err => {
      this.fuseSplashScreenService.hide();
    });
  }

  assignDataType() {
    let platformCommand = new PlatformCommand('AssignDataTypeCommand', this.flexSheetService.getApi());
    platformCommand = this.setPlatformCommandValue(platformCommand);
    const workbookSetId = this.flexSheetService.getCurrentWorkBookSetId();
    platformCommand.fieldValues['EventSourceId'] = workbookSetId;
    platformCommand.fieldValues['DestinationTransportId'] = workbookSetId;
    platformCommand.fieldValues['EventSourceApi'] = Api.Spreadsheet;
    platformCommand.fieldValues['IsEventSourceCommand'] = true;
    platformCommand.isCamelCase = true;
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(response => {
      this.invalidateSubject.invalidate();
      this.fuseSplashScreenService.hide();
    }, err => {
      this.fuseSplashScreenService.hide();
    });
  }

  protected readonly TableType = TableType;
}
